
import * as api from "../../../api"; 


  
export const getAllBusinessTypes = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getAllBusinessTypes(post);
          return(data);
       
        
     } catch (error) {
        
    }
}


export const createRazorpayLinkedAccTempEntry = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createRazorpayLinkedAccTempEntry(post);
          return(data);
       
        
     } catch (error) {
        
    }
}



